package com.dotdrives.web.ui

import kotlinx.coroutines.MainScope
import kotlinx.coroutines.awaitCancellation
import kotlinx.coroutines.cancel
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import react.useEffect
import react.useState

fun <T> useFlowState(flow: StateFlow<T>): T {
    val (value, setValue) = useState(flow.value)

    useEffect(flow) {
        val scope = MainScope()
        val collector = scope.launch {
            flow.collect { nextValue ->
                setValue(nextValue)
            }
        }

        try {
            awaitCancellation()
        } finally {
            collector.cancel()
            scope.cancel()
        }
    }

    return value
}
